import { createAction } from '@reduxjs/toolkit';

export const setLoading = createAction('firestopDocumentation/setLoading');

export const setSnackBarState = createAction(
  'firestopDocumentation/setSnackBarState'
);

export const setCompanyLogo = createAction(
  'firestopDocumentation/setCompanyLogo'
);

export const openCreateFirestopListDialog = createAction(
  'firestopDocumentation/openCreateFirestopListDialog'
);

export const closeCreateFirestopListDialog = createAction(
  'firestopDocumentation/closeCreateFirestopListDialog'
);

export const modifyCreateFirestopListAttribute = createAction(
  'firestopDocumentation/modifyCreateFirestopListAttribute'
);

export const addFirestopItemToCreate = createAction(
  'firestopDocumentation/addFirestopItemToCreate'
);

export const modifyFirestopItemToCreate = createAction(
  'firestopDocumentation/modifyFirestopItemToCreate'
);

export const removeFirestopItemToCreate = createAction(
  'firestopDocumentation/removeFirestopItemToCreate'
);

export const modifyFirestopAdditionAttribute = createAction(
  'firestopDocumentation/modifyFirestopAdditionAttribute'
);

export const editFirestopAttributes = createAction(
  'firestopDocumentation/editFirestopAttributes'
);

export const openFirestopList = createAction(
  'firestopDocumentation/openFirestopList'
);

export const closeViewAndEditFirestopListDialog = createAction(
  'firestopDocumentation/closeViewAndEditFirestopListDialog'
);

export const toggleEditListAttributes = createAction(
  'firestopDocumentation/toggleEditListAttributes'
);

export const cancelEditListAttributes = createAction(
  'firestopDocumentation/cancelEditListAttributes'
);

export const modifyFirestopListAttribute = createAction(
  'firestopDocumentation/modifyFirestopListAttribute'
);

export const openAddNewFirestopDialog = createAction(
  'firestopDocumentation/openAddNewFirestopDialog'
);

export const closeAddNewFirestopsDialog = createAction(
  'firestopDocumentation/closeAddNewFirestopsDialog'
);

export const openAddMultipleFirestopLocationsDialog = createAction(
  'firestopDocumentation/openAddMultipleFirestopLocationsDialog'
);

export const closeAddMultipleFirestopLocationsDialog = createAction(
  'firestopDocumentation/closeAddMultipleFirestopLocationsDialog'
);

export const openConfirmFirestopItemDeleteDialog = createAction(
  'firestopDocumentation/openConfirmFirestopItemDeleteDialog'
);

export const closeConfirmFirestopItemDeleteDialog = createAction(
  'firestopDocumentation/closeConfirmFirestopItemDeleteDialog'
);

export const openConfirmFirestopListDeleteDialog = createAction(
  'firestopDocumentation/openConfirmFirestopListDeleteDialog'
);

export const closeConfirmFirestopListDeleteDialog = createAction(
  'firestopDocumentation/closeConfirmFirestopListDeleteDialog'
);

export const openEditFirestopItemDialog = createAction(
  'firestopDocumentation/openEditFirestopItemDialog'
);

export const closeEditFirestopItemDialog = createAction(
  'firestopDocumentation/closeEditFirestopItemDialog'
);

export const setFirestopImageToAdd = createAction(
  'firestopDocumentation/setFirestopImageToAdd'
);

export const setFirestopImageToDelete = createAction(
  'firestopDocumentation/setFirestopImageToDelete'
);

export const openFirestopAdditionDialog = createAction(
  'firestopDocumentation/openFirestopAdditionDialog'
);

export const closeFirestopAdditionDialog = createAction(
  'firestopDocumentation/closeFirestopAdditionDialog'
);

export const setIsCreatingOrUpdatingFirestopData = createAction(
  'firestopDocumentation/setIsCreatingOrUpdatingFirestopData'
);

export const setFirestopImageDescription = createAction(
  'firestopDocumentation/setFirestopImageDescription'
);

export const removeFirestopImageDescription = createAction(
  'firestopDocumentation/removeFirestopImageDescription'
);

export const setIsPrintingFirestopListPdf = createAction(
  'firestopDocumentation/setIsPrintingFirestopListPdf'
);

export const openFirestopLocationsOverviewDialog = createAction(
  'firestopDocumentation/openFirestopLocationsOverviewDialog'
);

export const closeFirestopLocationsOverviewDialog = createAction(
  'firestopDocumentation/closeFirestopLocationsOverviewDialog'
);

export const setHighlightedFirestopItemId = createAction(
  'firestopDocumentation/setHighlightedFirestopItemId'
);

export const openFirestopCatalogsDialog = createAction(
  'firestopDocumentation/openFirestopCatalogsDialog'
);

export const closeFirestopCatalogsDialog = createAction(
  'firestopDocumentation/closeFirestopCatalogsDialog'
);

export const setFirestopListsSearchFilterValue = createAction(
  'firestopDocumentation/setFirestopListsSearchFilterValue'
);

export const setFirestopItemsSearchFilterValue = createAction(
  'firestopDocumentation/setFirestopItemsSearchFilterValue'
);

export const openFirestopLabelDialog = createAction(
  'firestopDocumentation/openFirestopLabelDialog'
);

export const closeFirestopLabelDialog = createAction(
  'firestopDocumentation/closeFirestopLabelDialog'
);

export const setFirestopLabelToDelete = createAction(
  'firestopDocumentation/setFirestopLabelToDelete'
);
